module.exports = __webpack_public_path__ + "img/chat.6122a8b4.svg";